<template>
    <div class="flex flex-col h-full">
        <div class="flex flex-row justify-between mb-6 mt-1">
            <h1 class="text-3xl font-semibold text-gray-900 -mt-1">
                {{ $t('activations.pageTitle') }}
            </h1>
        </div>

        <template v-if="hasLicensesToActivate">
            <activation-form
                :license-type-options="licenseTypeOptions"
                ref="activationForm"
                @onLicenseActivated="onLicenseActivated"
            />

            <div class="mt-10 pt-6 border-t border-gray-200" />

            <div class="flex flex-row items-center mb-2">
                <span class="text-2xl text-gray-700">
                    {{ $t('orders.activations.activationsHistory') }}
                </span>
            </div>
        </template>

        <activations-history ref="activationsHistory" />
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ActivationForm from '@/components/Activation/ActivationForm.vue';
    import ActivationsHistory from '@/components/Activation/ActivationsHistory.vue';

    export default {
        components: {
            ActivationsHistory,
            ActivationForm,
        },

        data() {
            return {
                //
            };
        },

        computed: {
            ...mapState([
                'licenseTypes',
            ]),

            licenseTypeOptions() {
                return this.licenseTypes.map(licenseType => {
                    return {
                        count: licenseType.unactivatedLicenses,
                        label: licenseType.localized_name[this.$i18n.locale],
                        platform: licenseType.platform,
                        value: licenseType.id,
                    };
                });
            },

            hasLicensesToActivate() {
                return this.licenseTypes
                    .filter(licenseType => licenseType.unactivatedLicenses > 0)
                    .length;
            },
        },

        methods: {
            onLicenseActivated(license) {
                this.$refs.activationsHistory.onLicenseActivated(license);
            },
        },
    };
</script>
